// Contato público da loja (WhatsApp / Instagram), digitado pelo vendedor em
// Configurações → Loja e mostrado na vitrine. A pessoa digita em qualquer
// formato ("(73) 99907-3081", "@matriz3d", "instagram.com/matriz3d/"), então
// guardamos só o essencial (dígitos com DDI / usuário) e montamos o link na hora.

const WHATSAPP_MIN = 12; // DDI (2) + DDD (2) + número fixo (8)
const WHATSAPP_MAX = 15;

// Só dígitos, já com DDI. Sem DDI (10 ou 11 dígitos: DDD + número) assume Brasil.
export const limparWhatsapp = (valor) => {
  let d = String(valor || "").replace(/\D/g, "");
  if (d.startsWith("00")) d = d.slice(2);
  if (d.length === 10 || d.length === 11) d = "55" + d;
  return d;
};

export const whatsappValido = (valor) => {
  const d = limparWhatsapp(valor);
  return d.length >= WHATSAPP_MIN && d.length <= WHATSAPP_MAX;
};

// Usuário sem "@", aceitando também o link do perfil. "" quando inválido.
export const limparInstagram = (valor) => {
  let v = String(valor || "").trim();
  v = v.replace(/^(https?:\/\/)?(www\.)?instagram\.com\//i, "");
  v = v.split(/[/?#]/)[0].replace(/^@+/, "");
  return /^[A-Za-z0-9._]{1,30}$/.test(v) ? v : "";
};

// 5573999073081 -> (73) 99907-3081 (números fora do Brasil ficam como +DDI...)
export const formatarWhatsapp = (valor) => {
  const d = limparWhatsapp(valor);
  if (!d) return "";
  if (d.startsWith("55") && (d.length === 12 || d.length === 13)) {
    const ddd = d.slice(2, 4);
    const numero = d.slice(4);
    const corte = numero.length - 4;
    return `(${ddd}) ${numero.slice(0, corte)}-${numero.slice(corte)}`;
  }
  return "+" + d;
};

export const linkWhatsapp = (valor, texto) => {
  if (!whatsappValido(valor)) return "";
  const base = `https://wa.me/${limparWhatsapp(valor)}`;
  return texto ? `${base}?text=${encodeURIComponent(texto)}` : base;
};

export const linkInstagram = (valor) => {
  const usuario = limparInstagram(valor);
  return usuario ? `https://www.instagram.com/${usuario}/` : "";
};

// O que vai pro doc público `lojas/{slug}`. Sempre devolve as duas chaves
// (vazias quando não há valor válido): o setDoc com merge mescla mapas, então
// omitir a chave deixaria o valor antigo publicado depois de a pessoa apagar.
export const contatoPublico = (contato = {}) => ({
  whatsapp: whatsappValido(contato?.whatsapp) ? limparWhatsapp(contato.whatsapp) : "",
  instagram: limparInstagram(contato?.instagram),
});
